import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { GoogleTranslate } from '../../../services/google.translate';
import { cloneDeep } from 'lodash';

@Component({
})
export default class PropertyDesc extends Vue {

   public title: string = 'PropertyDesc';

   private translator = new GoogleTranslate();

   public loadingTranslate = false;
   public supportTranslate = true;
   public ua: string = '';

   @Prop()
   public data: any;

   public displayData: any = {};

   public zhCN: boolean = false;

   public created() {
      // this.ua = window.navigator.userAgent.toLowerCase();
      // if (
      //    this.ua.indexOf('micromessenger') !== -1 ||
      //    this.ua.indexOf('dingtalk') !== -1
      // ) {
      this.supportTranslate = true;
      // }
   }

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      this.displayData = cloneDeep(val);
      console.log(this.displayData);
   }

   @Watch('zhCN', { immediate: true, deep: true })
   public async onTranslate(val: any, oldVal: any) {
      if (val) {
         this.loadingTranslate = true;
         const keys = Object.keys(this.displayData);
         for (let i = 0; i < keys.length; i++) {
            this.displayData[keys[i]] = await this.translator.translate(this.displayData[keys[i]], 'zh-CN');
         }
         this.loadingTranslate = false;
      } else {
         this.displayData = cloneDeep(this.data);
      }
   }
}
